export const embeddedPlayerCampaign = '?utm_source=faithlifetv.com&utm_medium=embedded-player&utm_campaign=embed';
export const launch7Campaign = '?utm_source=faithlifetv.com&utm_medium=branding-bug&utm_campaign=launch-stream';
export const productPageCampaign = '';
